//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowExpand(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 6.24264L12.2426 2L16.4853 6.24264V9.07107L13.2397 5.82545L13.2538 11H11.2456V5.82545L8 9.07107V6.24264Z" fill="currentColor" /><path d="M8 17.6569L12.2426 21.8995L16.4853 17.6569V14.8284L13.2397 18.074L13.2467 13H11.2385L11.2456 18.074L8 14.8284V17.6569Z" fill="currentColor" /></svg>;
}
export default IconArrowExpand;